// import React, { createContext, useReducer, useEffect } from "react";
// import { useHistory } from "react-router-dom";

// export const UserContext = createContext();

// const initialState = null;

// const reducer = (state, action) => {
//   switch (action.type) {
//     case "USER":
//       return action.payload;
//     case "CLEAR":
//       return null;
//     default:
//       return state;
//   }
// };

// export const UserProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(reducer, initialState);
//   const history = useHistory();

//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));
//     if (user) {
//       dispatch({ type: "USER", payload: user });
//     } else {
//       if (
//         history.location.pathname !== "/signin" &&
//         history.location.pathname !== "/signup"
//       ) {
//         history.push("/signin");
//       }
//     }
//   }, [dispatch, history]);

//   return (
//     <UserContext.Provider value={{ state, dispatch }}>
//       {children}
//     </UserContext.Provider>
//   );
// };
// import React, { createContext, useReducer, useContext } from "react";
// import { useLocation } from "react-router-dom";

// const UserContext = createContext();

// const initialState = null;

// const reducer = (state, action) => {
//   switch (action.type) {
//     case "USER":
//       return action.payload;
//     case "CLEAR":
//       return null;
//     default:
//       return state;
//   }
// };

// export const UserProvider = ({ children }) => {
//   const [state, dispatch] = useReducer(reducer, initialState);
//   const location = useLocation();

//   return (
//     <UserContext.Provider value={{ state, dispatch, location }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

// export const useUserContext = () => useContext(UserContext);
// export { UserContext };
// import { createContext, useReducer } from "react";

// import { createContext, useReducer } from "react";

// export const UserContext = createContext();

// const initialState = null;

// const userReducer = (state, action) => {
//   switch (action.type) {
//     case "USER":
//       return action.payload;
//     case "CLEAR":
//       return null;
//     default:
//       return state;
//   }
// };

// export { initialState, userReducer };
// import React, { createContext, useReducer } from "react";

// const initialState = null;

// const UserContext = createContext();

// const userReducer = (state, action) => {
//   switch (action.type) {
//     case "USER":
//       return action.payload;
//     default:
//       return state;
//   }
// };

// export { UserContext, userReducer, initialState };
import React, { createContext, useReducer } from "react";

const initialState = null;

const UserContext = createContext();

const userReducer = (state, action) => {
  switch (action.type) {
    case "USER":
      return action.payload;
    default:
      return state;
  }
};

export { UserContext, userReducer, initialState };
